
//
//  CNNIX Life, but better
//  @description :      Webpack entry JS
//  @author :           Kenneth Uzquiano (kenneth.uzquiano@warnermedia.com)
//

//  Providers / Themes
    import { GlobalProvider } from 'proj/contexts/global'; 
    import { ThemeProvider } from 'styled-components';
    import Theme, { Reset } from 'styles/theme';

//  Imports
    import { render } from 'react-dom';
    import Project from 'js/proj';
    import './support';

//  Start Interactive
    render(
        <GlobalProvider>
            <ThemeProvider theme={ Theme }>
                <Reset backgroundColor={ "#FFFFFF" } />
                <Project />
            </ThemeProvider>
        </GlobalProvider>,
        document.getElementById(PROJECT_ID)
    );
